import { loadShared } from './dashboardCache';

// What a click on a CRO's "Course enrollments" count on ATS opens: the enrollments averaged into that row (see
// ats_admissions.controller.js on the server). One place builds the URL, so the page that PREFETCHES on hover and the popup that
// LOADS on click share the very same remembered answer (dashboardCache.js).
export const CASE_LABEL = { actual: 'Actual', forecasted: 'Forecasted' };

export const atsAdmissionsUrl = ({ userId, caseType, month }) => {
  const params = new URLSearchParams({ userId: String(userId), caseType, month: month.format('YYYY-MM-DD') });
  return `warning-dashboard/ats-admissions?${params.toString()}`;
};

// Warm the remembered answer (no UI): called when the pointer rests on a count, so by the click it is usually there.
export const prefetchAtsAdmissions = (request) => {
  loadShared(atsAdmissionsUrl(request)).catch(() => {});
};
